// extracted by mini-css-extract-plugin
export default {"Container":"BusinessItem_Container__Nzc3n","Label":"BusinessItem_Label__2x5QP"};